import { useState } from "react";
import { Loader2, Info, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { errText } from "@/components/control/kit";
import { PublicShell, publicInput, publicButton, publicLabel, AuthNotice } from "@/components/control/PublicShell";

function Neutral({ message }) {
  return (
    <div role="status" data-testid="forgot-password-done" className="space-y-4">
      <p className="flex gap-2 rounded-lg border border-zinc-200 bg-zinc-50 p-4 text-sm text-zinc-800">
        <Info className="h-5 w-5 shrink-0" aria-hidden="true" />
        <span>{message} Ein Link ist 30 Minuten gültig und nur einmal verwendbar. Kommt keine E-Mail an, prüfe den Spam-Ordner oder wende dich an einen Super Admin.</span>
      </p>
    </div>
  );
}

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [error, setError] = useState(null);
  const [unavailable, setUnavailable] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) { setError("Bitte eine gültige E-Mail-Adresse angeben."); return; }
    setBusy(true);
    setError(null);
    setUnavailable(null);
    try {
      const { data } = await api.post("/auth/password-reset/request", { email });
      setDone(data.message);
    } catch (err) {
      // 503 is a global configuration state (same for every address), so it may be shown as such.
      if (err.response?.status === 503) setUnavailable(errText(err));
      else setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PublicShell title="Passwort-Link anfordern" subtitle="Die Rückmeldung zur Passwortanfrage verrät keine Kontoexistenz." testId="forgot-password-page">
      {done ? <Neutral message={done} /> : (
        <form onSubmit={submit} className="space-y-4" noValidate aria-busy={busy}>
          <AuthNotice title="Persönlichen Zugang bestätigen" text="Gib die E-Mail-Adresse deines Teamkontos ein." />
          {unavailable && (
            <p role="alert" data-testid="forgot-password-unavailable" className="flex gap-2 rounded-lg border border-orange-200 bg-orange-50 p-4 text-sm text-orange-800">
              <AlertTriangle className="h-5 w-5 shrink-0" aria-hidden="true" /> <span>{unavailable}</span>
            </p>
          )}
          <label htmlFor="reset-email" className={publicLabel}>E-Mail-Adresse</label>
          <input id="reset-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Noch nicht eingegeben"
            data-testid="forgot-password-email" className={publicInput} />
          {error && <p role="alert" data-testid="forgot-password-error" className="text-sm text-red-700">{error}</p>}
          <AuthNotice title="Neutrale Rückmeldung" text="Aus Sicherheitsgründen erhältst du immer dieselbe Antwort – unabhängig davon, ob ein Konto existiert." />
          <button type="submit" disabled={busy} data-testid="forgot-password-submit" className={publicButton}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />} {busy ? "Wird gesendet …" : "Link anfordern"}
          </button>
        </form>
      )}
    </PublicShell>
  );
}
